<template>
    <div class="flex flex-col h-screen max-w-4xl mx-auto p-4 bg-white shadow-md rounded-md relative">
        <div class="mb-2">
            <router-link to="/" class="no-underline text-blue-600">
                <h1 class="logo-text-chat">interbot</h1>
            </router-link>
        </div>
        <div class="flex items-center p-2 my-2 border-b border-gray-200">
            <img :src="coach.image" :alt="coach.name" class="w-20 h-20 rounded-full mr-4 object-cover">
            <div class="flex items-center justify-between flex-1">
                <h2 class="text-xl font-semibold">{{ coach.name }}</h2>
                    <button @click="showInfoModal = true" class="rounded-full bg-gray-200 hover:bg-gray-300 p-2 focus:outline-none">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                           <line x1="12" y1="8" x2="12.01" y2="8"></line>
                          </svg>
                    </button>
            </div>
          </div>
        <div class="flex flex-col flex-1 justify-start">
            <div class="mb-2 text-center text-gray-700">
                <!-- <h3>ID de esta sesión: {{ chatSessionId }} </h3> -->
            </div>
            <div id="chat-history" ref="chatHistoryDiv" class="border border-gray-300 rounded p-2 overflow-y-auto flex-1"
                :style="{ maxHeight: chatMaxHeight }">
                <ChatMessage v-for="(message, index) in chatHistory" :key="index" :message="message" />
            </div>
            <div class="flex items-center p-2 bg-gray-100 shadow-inner">
                <input v-model="newMessage" type="text"
                       placeholder="Escribe un mensaje... empieza con 'Hola' para iniciar la conversación"
                       required
                       @keyup.enter="sendMessage"
                      class="flex-1 border rounded p-2 mr-2 focus:outline-none focus:ring-2 focus:ring-blue-300"
                       style="padding-left: 10px;"
                />
                <button
                    type="button"
                    @click="sendMessage"
                    class="p-2 rounded-full bg-blue-500 hover:bg-blue-600 text-white focus:outline-none flex items-center justify-center"
                    :disabled="loading">
                     <span v-if="loading">
                       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-hourglass">
                            <path d="M6 2l6 8 6-8M6 22l6-8 6 8"/>
                            <path d="M2 12h20"/>
                         </svg>
                       </span>
                     <span v-else>
                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send">
                             <line x1="22" y1="2" x2="11" y2="13"></line>
                             <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                         </svg>
                     </span>
                </button>
            </div>
        </div>
          <CodeDialog
           v-if="showCodePopUp"
           :interviewLink="interviewLink"
            :intCode="intCode"
             @close="closeCode"
            />
        <CoachInfoModal
            :show="showInfoModal"
            :name="coach.name"
            :description="coach.description"
            :disclaimer="coach.disclaimer"
            :chatSessionId="chatSessionId"
             @close="showInfoModal = false"
              @newSession="startNewSession"
                />
    </div>
</template>

<script>
import axios from 'axios';
import ChatMessage from './ChatMessage.vue';
import CodeDialog from './CodeDialog.vue';
import CoachInfoModal from './CoachInfoModal.vue'


export default {
    name: 'ChatInterface',
    components: {
        ChatMessage,
         CodeDialog,
        CoachInfoModal
    },
    props: {
        coach: { type: Object, required: true },
        apiEndpoint: { type: String, required: true },
        coachName: {type: String, required: true},
    },
    data() {
        return {
            interviewCode: this.$route.query.code,
            newMessage: '',
            chatHistory: [],
            chatSessionId: null,
            loading: false,
            chatHistoryDiv: null,
            interviewCodeGenerated: false,
            showCodePopUp: false,
            showInfoModal: false,
            windowHeight: window.innerHeight,
             inputAreaHeight: 50 // Estimate the input area height
        };
    },
  computed: {
        interviewLink() {
            return `https://interbot.mx?code=${this.chatSessionId}`
        },
        intCode() {
            return `${this.chatSessionId}`
        },
       chatMaxHeight() {
           return `${this.windowHeight - (200 + this.inputAreaHeight) }px`
      },
    },
    async mounted() {
        if (this.interviewCode) {
            console.log("Interview Code", this.interviewCode);
            this.chatSessionId = this.interviewCode;
            this.interviewCodeGenerated = true;
            await this.checkSession();

        } else {
            this.chatSessionId = localStorage.getItem(`chatSessionId_${this.coach.name}`) || null;
            if (this.chatSessionId) {
                this.interviewCodeGenerated = true;
                await this.checkSession();
            } else {
                await this.generateInterviewCode();
            }
        }
        console.log("ChatSessionId", this.chatSessionId);
      window.addEventListener('resize', this.handleResize);
        this.$nextTick(() => {
               this.calculateInputAreaHeight();
            });
    },
     beforeUnmount() {
           window.removeEventListener('resize', this.handleResize);
         },
      methods: {
        showCode() {
            this.showCodePopUp = true;
        },
        closeCode() {
            this.showCodePopUp = false;
        },
           handleResize() {
             this.windowHeight = window.innerHeight;
            this.calculateInputAreaHeight();
        },
          calculateInputAreaHeight() {
                if (this.$refs.inputAreaContainer) {
                 this.inputAreaHeight = this.$refs.inputAreaContainer.offsetHeight;
                }
          },
         async generateInterviewCode() {
             try {
              const response = await axios.post(`${this.apiEndpoint}/generate-code-coach`, {coach: this.coach.name});
                this.chatSessionId = response.data.chatSessionId;
                this.interviewCodeGenerated = true;
              localStorage.setItem(`chatSessionId_${this.coach.name}`, this.chatSessionId);
            } catch (error) {
                console.error("Error al generar el código", error)
            }
        },
          async checkSession() {
            try {
              console.log("Checking session " + this.chatSessionId);
                const response = await axios.post(`${this.apiEndpoint}/chatHistory${this.coachName}`, {
                  chatSessionId: this.chatSessionId,
                   coach: this.coach.name,
                });


            if (response.data.chatSessionExists) {
                this.chatHistory = response.data.chatHistory;
                 if (this.interviewCode) {
                  localStorage.setItem(`chatSessionId_${this.coach.name}`, this.chatSessionId);
                }

                  this.$nextTick(() => {
                  if (this.$refs.chatHistoryDiv) {
                      this.$refs.chatHistoryDiv.scrollTop = this.$refs.chatHistoryDiv.scrollHeight;
                      console.log("Scrolling Again");
                  }
                });
            } else {
                if(this.interviewCode){
                this.chatSessionId = null; //Limpiar el id de sesión, ya que no existe en el backend.
                }
                  await this.generateInterviewCode();
                }
            } catch (error) {
                console.error('Error checking session:', error);
                }
          },
         formatTime(timestamp) {
            const date = new Date(timestamp);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
          async sendMessage() {
        if (this.newMessage.trim() !== '') {
            this.loading = true;
            const userMessage = {
                text: this.newMessage,
                type: 'user',
                timestamp: new Date().toISOString(),
            };

            this.chatHistory.push(userMessage);
            this.$nextTick(() => {
                if (this.$refs.chatHistoryDiv) {
                    this.$refs.chatHistoryDiv.scrollTop = this.$refs.chatHistoryDiv.scrollHeight;
                    console.log("Scrolling Again");
                }
            });

             const messageToSend = this.newMessage;
             this.newMessage = '';
                try {
                const response = await axios.post(`${this.apiEndpoint}/chat${this.coachName}`, {
                     message: messageToSend,
                     chatSessionId: this.chatSessionId,
                     coach: this.coach.name,
                });
                    const responseChatHistory = response.data.chatHistory;

                    this.chatHistory = responseChatHistory;
                     const lastMessage = responseChatHistory[responseChatHistory.length - 1]
                        if (lastMessage && lastMessage.type === 'system') {
                        let chatDisplayingIndex = 0;
                        let chatAccumulatedText = lastMessage.text;
                        console.log(lastMessage.text);
                        this.chatHistory[this.chatHistory.length - 1].text = "";
                        console.log("Borré el mensaje");
                        const displayChar = () => {
                            if (chatDisplayingIndex < chatAccumulatedText.length) {
                                this.chatHistory[this.chatHistory.length - 1].text = chatAccumulatedText.substring(0, chatDisplayingIndex + 1);
                                chatDisplayingIndex++;
                                this.$nextTick(() => {
                                    if (this.$refs.chatHistoryDiv) {
                                        this.$refs.chatHistoryDiv.scrollTop = this.$refs.chatHistoryDiv.scrollHeight;
                                        console.log("Scrolling Again");
                                    }
                                });
                                setTimeout(displayChar, 5, this.$refs.chatHistoryDiv.value);
                            } else {
                                //   chatAccumulatedText = "";
                            }
                        };
                        displayChar();

                    }
            } catch (error) {
              console.error('Error:', error);
            } finally {
                this.loading = false;
            }
        }
        },
         async startNewSession() {
         try {
                    await this.generateInterviewCode();
                    this.chatHistory = [];
                    this.newMessage = "";
                 } catch (error) {
                  console.error('Error starting new session:', error);
                 }

         },
    },
};
</script>